import React from 'react';

import {
  Checkbox,
  FormControl,
  FormHelperText,
  styled,
  Typography,
} from '@mui/material';

import { LeadIntent, ResponsePreference } from '@mewa/types';

import t from '../../../../libs/translate';
import { CheckboxWrapper } from '../base';
import { FormDataState } from '../hooks/use-form-data';
import { ConversionTranslations } from '../translations-query';

export const PhoneResponsePreference = React.memo(
  ({
    translations,
    state,
  }: {
    translations: ConversionTranslations;
    state: FormDataState;
  }) => {
    return (
      <Expander
        className={
          (state.phone.value?.length ?? 0) > 0 ||
          state.leadIntent.value === LeadIntent.recall
            ? 'expanded'
            : ''
        }
      >
        <ContentToExpand>
          <Typography
            component="p"
            variant="footnote"
            sx={{ marginBottom: '10px' }}
          >
            {t(translations, 'general_form_phone_response_preferences_note')}
          </Typography>
          <FormControl
            sx={{
              display: 'grid',
              gridTemplateColumns: 'repeat(4, auto) 1fr',
              alignItems: 'start',
              marginLeft: '-11px', // equalize the padding of the checkbox
              marginBottom: '30px',
            }}
          >
            <CheckboxWrapper
              sx={{
                display: 'contents',
              }}
              control={
                <Checkbox
                  checked={
                    state.responsePreference.value[ResponsePreference.morning]
                  }
                  onChange={({ target }) =>
                    state.responsePreference.changeValue((oldValue) => ({
                      ...oldValue,
                      [ResponsePreference.morning]: target.checked,
                    }))
                  }
                />
              }
              label={
                <Typography
                  component="p"
                  variant="footnote"
                  fontWeight="regular"
                  sx={{
                    paddingTop: '3px',
                    lineHeight: '200%',
                    marginRight: '40px',
                  }}
                >
                  {t(translations, 'general_form_response_preference_morning')}
                </Typography>
              }
            />
            <CheckboxWrapper
              sx={{
                display: 'contents',
              }}
              control={
                <Checkbox
                  checked={
                    state.responsePreference.value[ResponsePreference.afternoon]
                  }
                  onChange={({ target }) =>
                    state.responsePreference.changeValue((oldValue) => ({
                      ...oldValue,
                      [ResponsePreference.afternoon]: target.checked,
                    }))
                  }
                />
              }
              label={
                <Typography
                  component="p"
                  variant="footnote"
                  fontWeight="regular"
                  sx={{
                    paddingTop: '3px',
                    lineHeight: '200%',
                  }}
                >
                  {t(
                    translations,
                    'general_form_response_preference_afternoon',
                  )}
                </Typography>
              }
            />
            <FormHelperText sx={{ gridRow: '2 / 2' }}>&nbsp;</FormHelperText>
          </FormControl>
        </ContentToExpand>
      </Expander>
    );
  },
);

export const Expander = styled('div')({
  display: 'grid',
  gridTemplateRows: '0fr',
  overflow: 'hidden',
  transition: 'grid-template-rows var(--transition-duration)',

  '&.expanded': {
    gridTemplateRows: '1fr',
    overflow: 'visible',
  },
});

export const ContentToExpand = styled('div')({
  minHeight: 0,
  transition:
    'visibility var(--transition-duration), opacity var(--transition-duration)',
  transitionDelay: 'var(--transition-duration)',
  visibility: 'hidden',
  opacity: 0,

  '.expanded &': {
    visibility: 'visible',
    opacity: 1,
  },
});
